import axios from 'axios';

// Get all warehouse reorder points
export const getWarehouseReorders = async (filters = {}) => {
  try {
    const token = localStorage.getItem('token');

    // Build query string from filters
    const queryParams = new URLSearchParams();
    if (filters.warehouse_id) queryParams.append('warehouse_id', filters.warehouse_id);
    if (filters.part_id) queryParams.append('part_id', filters.part_id);

    const queryString = queryParams.toString();
    const url = `/api/warehouse-reorders${queryString ? `?${queryString}` : ''}`;

    const res = await axios.get(url, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching warehouse reorder points' };
  }
};

// Get warehouse reorder point by ID
export const getWarehouseReorderById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/warehouse-reorders/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching warehouse reorder point' };
  }
};

// Create new warehouse reorder point
export const createWarehouseReorder = async (reorderData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/warehouse-reorders', reorderData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating warehouse reorder point' };
  }
};

// Update warehouse reorder point
export const updateWarehouseReorder = async (id, reorderData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/warehouse-reorders/${id}`, reorderData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating warehouse reorder point' };
  }
};

// Delete warehouse reorder point
export const deleteWarehouseReorder = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/warehouse-reorders/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting warehouse reorder point' };
  }
};

// Bulk update warehouse reorder points
export const bulkUpdateWarehouseReorders = async (warehouseId, reordersData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/warehouse-reorders/bulk-update', {
      warehouse_id: warehouseId,
      reorders: reordersData
    }, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error bulk updating warehouse reorder points' };
  }
};

// Calculate reorder points based on technician count
export const calculateReorderPoints = async (warehouseId) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`/api/warehouse-reorders/calculate/${warehouseId}`, {}, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error calculating reorder points' };
  }
};
